/**
 * Os textos do cliente do mundo (docs/08 secao 10): nenhum texto de UI literal em componente.
 *
 * Dicionario proprio, e nao o do `web2`: o pedido que abriu o modo manda nao mexer na stack do `web2`, e
 * importar dele amarraria os dois builds. Extrair um pacote comum e decisao para quando a repeticao doer
 * (ADR 0042).
 */
export const t = {
  title: 'Modo História',
  loading: 'Entrando no mundo…',
  backToGame: 'Voltar ao jogo',
  /** Os rotulos dos seis emotes (docs/21 secao 7), para leitor de tela e dica do botao. */
  emotes: {
    bar: 'Emotes',
    wave: 'Acenar',
    laugh: 'Rir',
    surprise: 'Surpresa',
    thumbs_up: 'Joia',
    angry: 'Bravo',
    heart: 'Coração',
  },
  denied: {
    title: 'O Modo História ainda não está aberto para você',
    body: 'Ele está em teste com um grupo pequeno de jogadores. Quando abrir para mais gente, o jogo avisa.',
  },
  /** O desafio no mapa (docs/21 secao 8). */
  challenge: {
    challenge: 'Desafiar {nick}',
    tooFar: 'Chegue mais perto de {nick} para desafiar.',
    incoming: '{nick} desafiou você para um duelo!',
    accept: 'Aceitar',
    decline: 'Recusar',
    pending: 'Esperando {nick} responder…',
    seconds: '{n} s',
    starting: 'Preparando o duelo…',
    close: 'Fechar',
    closed: {
      DECLINED: 'O desafio foi recusado.',
      EXPIRED: 'O desafio expirou sem resposta.',
      OUT_OF_RANGE: 'Vocês se afastaram, e o desafio caiu.',
      LEFT: 'O outro jogador saiu do mundo.',
      BUSY: 'Esse jogador não pode ser desafiado agora.',
      UNAVAILABLE: 'Não foi possível criar o duelo. Tente de novo em instantes.',
      NO_ACCESS: 'Um dos jogadores não pode mais entrar no Modo História.',
      INVALID_DECK: 'Um dos decks não está válido para duelar.',
      BUSY_IN_DUEL: 'Um dos jogadores já está em outro duelo.',
    },
    yourDeck: 'Seu deck ativo não está válido. Ajuste-o no jogo antes de duelar.',
  },
  /** A conversa e o duelo com um NPC (docs/21 secoes 12 e 13). As falas do NPC sao conteudo, nao vivem aqui. */
  npc: {
    talk: 'Falar com {name}',
    duel: 'Duelar',
    accept: 'Duelar agora',
    notNow: 'Agora não',
    leave: 'Sair',
    starting: 'Preparando o duelo…',
    closed: {
      TOO_FAR: 'Chegue mais perto para duelar.',
      TOO_SOON: 'Espere um instante antes de pedir outro duelo.',
      BUSY: 'Você não pode duelar agora.',
      NO_ACCESS: 'Você não pode mais entrar no Modo História.',
      INVALID_DECK: 'Seu deck ativo não está válido. Ajuste-o no jogo antes de duelar.',
      BUSY_IN_DUEL: 'Você já está em outro duelo.',
      NPC_UNAVAILABLE: 'Este personagem não está duelando agora.',
      UNAVAILABLE: 'Não foi possível criar o duelo. Tente de novo em instantes.',
    },
  },
  /** A entrada recusada porque o jogador esta em outro modo (docs/09 secao 1.1). */
  refused: {
    title: 'Você não pode entrar no mundo agora',
    reason: {
      IN_CHAMPIONSHIP: 'Você está num campeonato. Termine-o antes de entrar no Modo História.',
      ALREADY_QUEUED: 'Você está na fila de duelo. Saia da fila antes de entrar no Modo História.',
      ALREADY_INVITING: 'Você tem um convite de Duelo Rápido aberto. Cancele-o antes de entrar no Modo História.',
      BUSY_IN_DUEL: 'Você está num duelo. Termine-o antes de entrar no Modo História.',
      OTHER: 'Você está em outro modo do jogo agora.',
    },
  },
  failed: {
    title: 'Não foi possível entrar no mundo',
    body: 'Verifique sua conexão e tente de novo.',
    retry: 'Tentar de novo',
  },
} as const
